import {
    FETCH_RAW_DATA,
    FETCH_MORE_RAW_DATA,
    REMOVE_IRR_POST,
    SENTIMENT_UPDATE,
    BULK_SENTIMENT_UPDATE,
    BULK_MARK_IRR_UPDATE,
    SET_CREATE_SPARK_MODAL_SHOW,
    GET_TEAMS_I_BELONG_TO,
    SET_TAG_CLIENT_MODAL_SHOW,
    GET_CLIENTS,
    VALIDATE_TOKEN,
    ADD_SPARK,
    // TAG_CLIENT,
    EMAIL_POST,
    UPDATE_MARK_IRR_FOR_ALL,
    UPDATE_SENTIMENT_FOR_ALL,
    UPDATE_SENTIMENT_FOR_VIRAL_POSTS,
    UPDATE_MARK_IRR_FOR_VIRAL_POSTS,
    SET_PLATFORM_NAME,
    FETCH_POST_INFO,
    NEW_TOTAL_COUNT,
} from "../actions/rawDataAction";
//import { FETCH_POST_INFO } from '../epics/index'

import { isFulfilled, isPending, isRejected } from "./reducerUtils";
import { toast } from "react-toastify";
import { BLOCK_SOURCE_MESSAGE } from "../actions/rawDataAction";

const rawDataReducer = (
    state = {
        rawData: [],
        rawDataFetching: false,
        rawDataFetched: false,
        hasMore: true,
        offset: 1,
        total: 0,
        noOfPostsFetched: 0,
        // collectionsList: [], TODO fetchcollectionlist
        // collectionsListFetching: false,
        createSparkModalOpen: false,
        tagClientModalOpen: false,
        teamsIBelongToOptions: [],
        active_company_list: [],
        sparkTitle: "",
        sparkUrl: "",
        sparkImage: "",
        postInfo: undefined,
        postInfoStatus: "",
        postComments: [],
        postReplys: [],
        platformName: "",
        auto_push_in_operation: false,
        valid_token: false,
    },
    action,
) => {
    switch (action.type) {
        case isPending(FETCH_RAW_DATA):
            if (!state.auto_push_in_operation) {
                state = {
                    ...state,
                    rawDataFetching: true,
                    rawData: [],
                };
            } else {
                state = {
                    ...state,
                    rawDataFetching: true,
                };
            }

            break;
        case isRejected(FETCH_RAW_DATA):
            state = {
                ...state,
                rawDataFetching: false,
            };
            break;
        case isFulfilled(FETCH_RAW_DATA):
            state = {
                ...state,
                rawDataFetching: false,
                rawDataFetched: true,
                rawData: action.payload.hits.hits,
                total: action.payload.hits.total,
                max_total: action.payload.hits.total,
                offset: action.payload.offset,
                hasMore: action.payload.hits.hits.length < action.payload.hits.total,
                noOfPostsFetched: action.payload.hits.hits.length,
            };
            break;
        case isPending(FETCH_MORE_RAW_DATA):
            state = {
                ...state,
                rawDataFetching: true,
            };
            break;
        case isRejected(FETCH_MORE_RAW_DATA):
            state = {
                ...state,
                rawDataFetching: false,
            };
            break;
        case isFulfilled(FETCH_MORE_RAW_DATA):
            state = {
                ...state,
                rawDataFetching: false,
                rawData: state.rawData.concat(action.payload.hits.hits),
                offset: state.offset + 1,
                hasMore: state.noOfPostsFetched + action.payload.hits.hits.length < state.total,
                noOfPostsFetched: state.noOfPostsFetched + action.payload.hits.hits.length,
            };
            break;
        // case isFulfilled(REMOVE_IRR_POST):
        //     state = {
        //         ...state,
        //         rawData: state.rawData.filter((post) => post._id !== action.payload.postId),
        //     };
        //     toast.success("Successfully Marked As Irrelevant");
        //     break;
        case SENTIMENT_UPDATE:
            toast.success("Sentiment has been updated");
            state = {
                ...state,
                rawData: action.payload,
                rawDataFetching: false,
            };
            break;
        case BULK_SENTIMENT_UPDATE:
            state = {
                ...state,
                rawData: [],
                rawDataFetching: true,
            };
            break;
        case isFulfilled(BULK_MARK_IRR_UPDATE):
            state = {
                ...state,
                rawData: state.rawData.filter((post) => action.payload.ids.indexOf(post._id) === -1),
            };
            toast.success("Successfully Marked As Irrelevant");
            break;

        case SET_CREATE_SPARK_MODAL_SHOW:
            state = {
                ...state,
                createSparkModalOpen: action.payload.show,
                sparkTitle: action.payload.title,
                sparkImage: action.payload.image,
                sparkUrl: action.payload.url,
            };
            break;
        case SET_TAG_CLIENT_MODAL_SHOW:
            state = {
                ...state,
                tagClientModalOpen: action.payload.show,
            };
            break;
        case isFulfilled(GET_TEAMS_I_BELONG_TO):
            state = {
                ...state,
                teamsIBelongToOptions: action.payload.teams.map((team) => {
                    return { key: team.id, value: team.id, text: team.name, members: team.members };
                }),
            };
            break;
        case isFulfilled(GET_CLIENTS):
            state = {
                ...state,
                active_company_list: action.payload.map((client) => {
                    return { key: client.lite_company_id, value: client.lite_company_id, text: client.name };
                }),
            };
            break;
        case isFulfilled(VALIDATE_TOKEN):
            state = {
                ...state,
                valid_token: action.payload.status == "success" ? true : false,
            };
            break;
        case isFulfilled(ADD_SPARK):
            toast.success("Successfully Add Spark");
            break;
        // case TAG_CLIENT: {
        //     let current_rawData = state.rawData;
        //     let active_post = current_rawData.find((elem) => elem._id === action.id.split(":")[1]);
        //     active_post._source.company_ids = active_post._source.company_ids.concat(action.cmpny_list);
        //     toast.success("Successfully tagged clients");
        //     break;
        // }
        case isFulfilled(EMAIL_POST):
            toast.success("Email Sent Successfully");
            break;
        case isFulfilled(UPDATE_SENTIMENT_FOR_ALL):
            //toast.success('Sucessfully Updated Sentiment Of All Posts')
            toast.success("Changes will be processed and visible shortly.");

            break;
        case isFulfilled(UPDATE_MARK_IRR_FOR_ALL):
            //toast.success('Sucessfully Marked The Selected Posts As Irrelevant')
            toast.success("Changes will be processed and visible shortly.");
            break;
        case isPending(FETCH_POST_INFO):
            state = {
                ...state,
                postInfoStatus: "pending",
                postInfo: undefined,
            };
            break;
        case isFulfilled(FETCH_POST_INFO):
            action.payload.post_id = action.payload.post_id.split(":")[1];
            state = {
                ...state,
                postInfoStatus: "",
                postInfo: action.payload,
            };
            break;
        case isRejected(FETCH_POST_INFO):
            state = {
                ...state,
                postInfoStatus: "rejected",
            };
            break;
        case SET_PLATFORM_NAME:
            state = {
                ...state,
                platformName: action.payload,
            };
            break;
        // case isRejected("FETCH_POST_COMMENTS"):
        //     state = {
        //         ...state,
        //         postCommentsFetching: false,
        //         postCommentsRejected: true,
        //     };
        //     break;
        // case isFulfilled("FETCH_POST_COMMENTS"):
        //     state = {
        //         ...state,
        //         postComments: action.payload,
        //         postCommentsFetching: false,
        //     };
        //     break;
        // case isPending("FETCH_POST_COMMENTS"):
        //     state = {
        //         ...state,
        //         postComments: [],
        //         postCommentsFetching: true,
        //         postCommentsRejected: false,
        //     };
        //     break;

        case isRejected("FETCH_POST_REPLYS"):
            state = {
                ...state,
                postReplysFetching: false,
                postReplysRejected: true,
            };
            break;
        case isFulfilled("FETCH_POST_REPLYS"):
            state = {
                ...state,
                postReplys: action.payload,
                postReplysFetching: false,
            };
            break;
        case isPending("FETCH_POST_REPLYS"):
            state = {
                ...state,
                postReplys: [],
                postReplysFetching: true,
                postReplysRejected: false,
            };
            break;
        case BLOCK_SOURCE_MESSAGE:
            return { ...state, block_source_message: action.payload };
        case NEW_TOTAL_COUNT:
            if (action.count > state.max_total) {
                return { ...state, max_total: action.count };
            }
            break;
        case "AUTO_PUSH_CALL":
            return { ...state, auto_push_in_operation: action.payload };

        default:
            return state;
    }
    return state;
};

export default rawDataReducer;
